export default __webpack_public_path__ + "static/media/icons8-flooring.23b98be4.svg";